export const CompanyPostCategoryTypes = {
   PRIDEWORLD: 1,
   LGBTQPRIDE: 2
};